import React from "react";

import Dropdown from "react-dropdown";

import { IoIosArrowDown } from "react-icons/io";

import "./styles.css";

const arrow = (state) => (
  <div className={`dropdown-arrow ${state}`}>
    <IoIosArrowDown />
  </div>
);

const Dpdown = (props) => {
  const { data, changeHandle } = props;

  return (
    <Dropdown
      options={data}
      value={data[0]}
      onChange={changeHandle}
      arrowClosed={arrow("arrow-closed")}
      arrowOpen={arrow("arrow-opened")}
    />
  );
};

export default Dpdown;
